"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const debounce_1 = __importDefault(require("lodash/debounce"));
const hooks_1 = require("../../hooks");
// eslint-disable-next-line max-lines-per-function
function PenDrawPanel({ curves, width, height, color, size, opacity, offset = { x: 0, y: 0 }, drawable, drawOutside, className, onPaintEnd, setCurves, isGlobalPen = true, }, ref) {
    // const [curves, setCurves] = useState<Pen2DCurve[]>([]);
    const canvasRef = (0, react_1.useRef)();
    const [onPaintStartHandler, onPaintHandler, onPaintEndHandler] = (0, hooks_1.usePaints)({
        drawable,
        color,
        opacity,
        size: size * 5,
        offset,
        curves,
        setCurves,
        onPaintEnd,
        isGlobalPen,
    });
    (0, react_1.useEffect)(() => {
        if (!canvasRef.current) {
            return;
        }
        const element = canvasRef.current;
        const events = (0, ui_1.getPointersEvents)();
        const onPaintEndHandlerDebounced = (0, debounce_1.default)(onPaintEndHandler, 50);
        element.addEventListener(events.down, onPaintStartHandler);
        element.addEventListener(events.move, onPaintHandler);
        element.addEventListener(events.up, onPaintEndHandlerDebounced);
        if (!drawOutside) {
            element.addEventListener(events.cancel, onPaintEndHandlerDebounced);
            element.addEventListener(events.leave, onPaintEndHandlerDebounced);
        }
        return () => {
            element.removeEventListener(events.down, onPaintStartHandler);
            element.removeEventListener(events.move, onPaintHandler);
            element.removeEventListener(events.up, onPaintEndHandlerDebounced);
            element.removeEventListener(events.cancel, onPaintEndHandlerDebounced);
            element.removeEventListener(events.leave, onPaintEndHandlerDebounced);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawOutside, onPaintStartHandler, onPaintHandler, onPaintEndHandler]);
    (0, react_1.useEffect)(() => {
        if (!canvasRef.current) {
            return;
        }
        const context = canvasRef.current.getContext('2d');
        if (!context) {
            return;
        }
        context.lineJoin = 'round';
        context.lineCap = 'round';
        context.clearRect(0, 0, width, height);
        curves === null || curves === void 0 ? void 0 : curves.forEach(curve => {
            context.beginPath();
            context.lineWidth = curve.size;
            context.strokeStyle = curve.color;
            for (let i = 0; i < curve.points.length - 1; i++) {
                const point1 = curve.points[i];
                const point2 = curve.points[i + 1];
                const midPoint = (0, ui_1.getMidPointBetween)(point1, point2);
                if (isGlobalPen) {
                    context.quadraticCurveTo(point1.x * width, point1.y * height, midPoint.x * width, midPoint.y * height);
                }
                else {
                    context.quadraticCurveTo(point1.x, point1.y, midPoint.x, midPoint.y);
                }
            }
            context.stroke();
            context.closePath();
        });
    }, [width, height, curves, isGlobalPen]);
    const setRef = (newRef) => {
        if (ref) {
            const tempRef = ref;
            tempRef.current = newRef;
        }
        if (canvasRef) {
            canvasRef.current = newRef;
        }
    };
    return ((0, jsx_runtime_1.jsx)(Canvas, { ref: setRef, className: className, width: width, height: height, role: "dialog", "aria-label": "penDraw", "data-e2e": 'PenDrawPanel_Canvas' }));
}
exports.default = (0, react_1.forwardRef)(PenDrawPanel);
const Canvas = styled_components_1.default.canvas `
  position: absolute;
  top: 0;
  left: 0;

  user-select: none;
`;
